import { COLOR, Tag, textStyles } from '@cosuno/cosuno-ui';
import styled, { css } from 'styled-components';

import { font, gradients } from '~/shared/utils/styles';

export const Cancellation = styled.span<{ $color?: COLOR }>`
  ${textStyles.bodySmall450}
  color: ${(props) => props.$color};
`;

export const CostWrapper = styled.div<{ $color: COLOR }>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: ${(props) => props.$color};
`;

export const Cost = styled.span<{
  $size: 'regular' | 'medium' | 'small' | 'large';
  $color?: COLOR | string;
}>`
  ${(props) =>
    props.$size === 'regular' &&
    css`
      ${font.size(20)}
      font-weight: 900;
    `}
  ${(props) => props.$size === 'small' && textStyles.bodyMedium450}
  ${(props) => props.$size === 'medium' && textStyles.labelLarge500}
  ${(props) => props.$size === 'large' && textStyles.titleMedium700}
  ${(props) =>
    props.$color &&
    css`
      color: ${props.$color};
    `}
  line-height: inherit;
`;

const sizeToFont = {
  large: 32,
  medium: 24,
  small: 20,
} as const;

export const CostValue = styled.span<{ $size: 'large' | 'medium' | 'small' }>`
  ${(props) => font.size(sizeToFont[props.$size])}
  font-weight: 900;
`;

export const StyledTag = styled(Tag)`
  background: ${gradients.premium};
  color: ${COLOR.white};
  height: max-content;
`;

export const InlineWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const InlineCostWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-end;
  line-height: 24px;
`;
